// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-popover-close-btn{align-items:center;color:#7f839c;cursor:pointer;display:flex;height:1rem;justify-content:center;position:absolute;right:.25rem;top:.25rem;width:1rem}.v-popover-close-btn>svg{height:.75rem;width:.75rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
